<template>
  <div class="page loan-history">
    <navigation>我的账单</navigation>
    <div class="repay-banner" v-if="repayAmt > 0" 
         data-sensors-exposure-event-name="Element_Exposure"  
         data-sensors-exposure-property-caseId="QUICK_REPAYMENT"
         data-sensors-exposure-property-element_positon="banner"
    >
      <div class="info">
        <span>当前应还账单 (元)</span>
        <p>{{ repayAmt | currency }}</p>
      </div>
      <div class="repay-btn" @click="$router.push('/quickRepay/index')">一键还款</div>
    </div>
    <div class="repay-tabs" v-if="monitor === 'N' && expenseList.length > 0">
      <div class="tab-item" :class="{ current: currentTab === 'repayOrder' }" @click="currentTab = 'repayOrder'">
        还款账单
      </div>
      <div class="tab-item" :class="{ current: currentTab === 'expenseOrder' }" @click="currentTab = 'expenseOrder'">
        消费账单
      </div>
    </div>
    <div class="api-banner">
      <!-- api 老用户 用户引导关注的 banner -->
      <guideApiFollow placeEnum="BILL_LIST"></guideApiFollow>
    </div>
    <bannerCard :banner="tips.banner" v-if="tips && tips.banner" data-sensors-exposure-property-element_positon="banner" data-sensors-exposure-event-name="Element_Exposure" :data-sensors-exposure-property-element_type="tips.banner.textKey" :data-sensors-exposure-property-element_pop_type="tips.banner.popKey"></bannerCard>
    <template v-if="currentTab === 'repayOrder'">
      <section v-if="orderList.length === 0" class="no-loan">
        <img src="./images/no_history.png" />
        <div class="tips">暂无账单</div>
      </section>
      <section class="loan-list" v-else>
        <div class="unit" @click="goRepaymentDetail(value)" v-for="(value, index) of orderList" :key="index">
          <div class="platform">
            <img src="./images/icon_tmd.png" alt="天美贷" />
            <span class="name">天美贷</span>
          </div>
          <div class="info">
            <div class="item">
              <div class="money-title">借款金额</div>
              <div class="money-content">
                {{ value.applyAmount | currency }}
              </div>
            </div>
            <div class="item" :class="{ danger: value.orderBillStatus === 'OVERDUE' }">
              <div class="money-title">
                <template v-if="value.orderBillStatus === 'OVERDUE'">逾期应还 (元)</template>
                <template v-if="value.orderBillStatus === 'PROCESSING' && value.repayAmt">当前可还 (元)</template>
                <template v-if="value.orderBillStatus === 'FINISH' || value.repayAmt === 0">查看详情</template>
              </div>
              <div class="money-content" v-if="value.orderBillStatus !== 'FINISH' && value.repayAmt > 0">
                {{ value.repayAmt }}
              </div>
            </div>
          </div>

          <div class="line"></div>
          <div class="bottom-content">
            <div class="item">还款日：每月{{ value.pmtDueDate }}日</div>
            <div class="item">
              借款日期：{{ value.creditStartTime | date("YYYY/MM/DD") }}
            </div>
          </div>
          <div class="content-title">
            <orderStatus :status="value.orderBillStatus" orderType="b" />
          </div>
        </div>
      </section>
    </template>
    <template v-if="currentTab === 'expenseOrder'">
      <section v-if="expenseList.length === 0" class="no-loan">
        <img src="./images/no_history.png" />
        <div class="tips">暂无消费账单</div>
      </section>
      <section v-else class="expense-list">
        <div v-for="item in expenseList" :key="item.billNo" class="expense-item" @click="handleRouteDetail(item.billNo)">
          <div class="item-title">{{ item.rightName }}</div>
          <div class="item-content">
            <!-- <div class="item-amount">{{item.schdLoanServFee | currency}}（元）</div> -->
            <div class="item-time">
              {{ item.lendingDate | date("YYYY/MM/DD") }}
            </div>
          </div>

          <div class="right-info" :class="{ danger: item.orderRightStatus === 'OVERDUE' }">
            <div class="money-title">
              <template v-if="item.orderRightStatus === 'OVERDUE'">超期应付 (元)</template>
              <template v-if="item.orderRightStatus === 'PROCESSING' && item.repayAmt > 0">当前可付 (元)</template>
              <template v-if="item.orderRightStatus === 'FINISH' || item.repayAmt === 0">查看详情</template>
            </div>
            <div class="money-content" v-if="item.orderRightStatus !== 'FINISH' && item.repayAmt > 0">
              {{ item.repayAmt  | currency}}
            </div>
          </div>

          <div class="item-tag">
            <orderStatus :status="item.orderRightStatus" orderType="r" />
          </div>
        </div>
      </section>
    </template>
    <!-- 返回首页 -->
    <back-home-drag y="13"></back-home-drag>
    <dragCoupon :flow="tips.flow" v-if="tips && tips.flow" ftype="MY_BILL_LIST"></dragCoupon>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

import { setKey } from '../../assets/utils'
import { mapState } from 'vuex/dist/vuex.common.js'
// import { getKey } from '../../assets/utils'
import checkBindCard from '@/assets/mixins/checkBindCard'

export default {
  name: 'loan-history',
  customReadyNotify: true,
  mixins: [checkBindCard],
  components: {
    bannerCard: () => import('./components/banner-card'),
    dragCoupon: () => import('./components/drag-coupon'),
    guideApiFollow: () => import('@/components/guide-api-follow/index.vue'),
    orderStatus: () => import('./components/order-status')
  },
  data () {
    return {
      currentTab: 'repayOrder', // tab名：repayOrder、expenseOrder
      loanStory: [],
      orderList: [],
      expenseList: [],
      tips: {},
      repayAmt: 0
    }
  },
  computed: {
    ...mapState('user', {
      monitor: (state) => state.monitor
    })
  },
  async created () {
    // 一键还款会缓存订单和权益勾选的数据，进入这里清空一次
    sessionStorage.removeItem('repayOrderSelect')
    sessionStorage.removeItem('repayExpenseSelect')
    setKey('repayEntry', '/repayment/history')
    this.getComputedStyle()
    this.getLoanBilltip()
    await Promise.all([
      this.getOrderList(),
      this.getExpenseList(),
      this.monitorX()
    ])
    this.$bus.$emit('ready')

    const { currentTab } = this.$route.query
    if (currentTab) {
      this.currentTab = currentTab
    }
  },

  methods: {
    ...mapActions('order', [
      'getOrderHisX',
      'queryExpenseListX',
      'loanBillTipX',
      'onceClickRepaymentX'
    ]),
    ...mapMutations('user', ['setUserInfo']),
    ...mapActions('user', ['monitorX']),
    async getComputedStyle () {
      const { success, data } = await this.onceClickRepaymentX()
      if (success && data) {
        this.repayAmt = data.repayAmt
      }
    },
    async getLoanBilltip () {
      const { success, data } = await this.loanBillTipX({
        popType: 'MY_BILL_LIST'
      })
      if (success) {
        this.tips = data
      }
    },
    // 获取借款历史
    async getOrderList () {
      const response = await this.getOrderHisX()
      if (response.success) {
        this.orderList = response.data.sysOrderLine
          .map((item) => {
            item.orderOutLineInfo = item.orderOutLineInfo.map((subItem) => {
              subItem.loanPlatform = item.type
              subItem.orderBillStatus = subItem.orderBillStatus
              subItem.repayAmt = subItem.repayAmt
              return subItem
            })
            return item.orderOutLineInfo
          })
          .reduce((a, b) => {
            return a.concat(b)
          }, [])
      }
    },
    // 获取消费账单
    async getExpenseList () {
      const { success, data } = await this.queryExpenseListX()
      if (success && data) {
        this.expenseList = data.bills || []
        this.expenseList.map(item => {
          item.rightName = item.rightName
          item.orderRightStatus = item.orderRightStatus
          item.repayAmt = item.repayAmt
          return item
        })
      }
    },

    // 路由跳转
    goRepaymentDetail (item) {
      let params = {
        orderId: item.orderId, // 订单号（颜值贷）
        loanPlatform: item.loanPlatform,
        productCd: item.productCd,
        from: item.hasCompleted
      }
      this.$router.push({ path: '/repayment/detail', query: params })
    },
    // 跳转消费账单详情页面
    handleRouteDetail (billNo) {
      this.$router.push({
        path: '/repayment/detail-expense',
        query: {
          repayBillNo: billNo
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";

.loan-history {
  height: 100%;
  position: relative;
  background-color: #fafafa;
  overflow: auto;

  .repay-banner {
    padding: 60px 40px;
    background: #fff;
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .info {
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #666666;
      }

      p {
        font-family: DIN, DIN;
        font-weight: 500;
        font-size: 66px;
        color: #333333;
      }
    }

    .repay-btn {
      border-radius: 36px;
      border: 2px solid #ff4633;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #ff4633;
      padding: 16px 50px;
    }
  }

  .api-banner {
    width: 670px;
    margin: 20px 40px;
  }

  .title {
    font-size: 82px;
    font-family: PingFangSC-Light;
    font-weight: 300;
    color: #333333;
    line-height: 1;
    margin-top: 21px;
    padding-left: 50px;
  }

  .repay-tabs {
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    padding: 0 50px;

    .tab-item {
      font-size: 34px;
      color: #bbbbbb;
      position: relative;
      height: 98px;
      line-height: 98px;
      font-weight: bold;

      &.current {
        color: #333333;

        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 42px;
          height: 4px;
          background-color: #333333;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .no-loan {
    width: 100%;

    img {
      width: 408px;
      height: 250pxm;
      margin-top: 196px;
      margin-left: 173px;
    }

    .tips {
      font-size: 26px;
      font-family: PingFangSC-Regular;
      color: #999999;
      line-height: 1;
      text-align: center;
      margin-top: 26px;
    }
  }

  .loan-list {
    margin-top: 20px;

    .unit {
      background-color: #ffffff;
      position: relative;
      width: 670px;
      margin-bottom: 20px;
      left: 40px;
      border-radius: 20px;
      font-size: 32px;

      .platform {
        position: relative;

        img {
          width: 48px;
          height: 48px;
          margin-top: 42px;
          margin-left: 30px;
        }

        .name {
          position: absolute;
          margin-left: 15px;
          top: 46px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 40px;
        }
      }

      .bottom-content {
        font-size: 24px;
        color: #666666;
        display: flex;
        justify-content: space-between;
        padding: 20px 30px;
      }

      .info {
        display: flex;
        justify-content: space-between;
        margin: 0 30px;
        padding: 30px 30px 30px 0;
        border-bottom: 1px solid #eee;
        background: url(./images/arrow.png) no-repeat;
        background-size: 9px 16px;
        background-position-x: right;
        background-position-y: 60px;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: center;

          &:last-child {
            align-items: flex-end
          }

          &.danger * {
            color: #FB4A46;
          }
        }
      }

      .money-title {
        top: 205px;
        left: 108px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
      }

      .money-content {
        top: 157px;
        left: 108px;
        font-size: 34px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: #333333;
        line-height: 41px;
      }

      .time-title {
        position: absolute;
        top: 205px;
        left: 453px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        color: #666666;
        line-height: 1;
      }

      .content-title {
        position: absolute;
        top: 0px;
        right: 0px;

        img {
          width: 106px;
          height: 106px;
        }
      }
    }
  }

  .expense-list {
    padding: 30px 40px;

    .expense-item {
      background-color: #fff;
      border-radius: 20px;
      position: relative;
      padding: 60px 40px;

      .right-info {
        display: flex;
        flex-direction: column;
        position: absolute;
        right: 30px;
        top: 60px;
        background: url(./images/arrow.png) no-repeat;
        background-size: 9px 16px;
        background-position-x: right;
        background-position-y: center;
        padding-right: 30px;
        height: 80px;
        justify-content: center;

        &.danger * {
          color: #FB4A46 !important;
        }

        .money-title {
          top: 205px;
          left: 108px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 40px;
        }

        .money-content {
          top: 157px;
          left: 108px;
          font-size: 34px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: #333333;
          line-height: 41px;
          text-align: right;
        }

      }

      &+.expense-item {
        margin-top: 30px;
      }

      .item-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #333333;
        line-height: 45px;
      }

      .item-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item-amount {
          font-size: 44px;
          color: #333333;
          font-weight: bold;
          font-family: DIN-Medium, DIN;
        }

        .item-time {
          margin-top: 10px;
          font-size: 28px;
          color: #666666;
        }
      }

      .item-tag {
        position: absolute;
        font-size: 0;
        top: 0;
        right: 0;

        img {
          width: 106px;
          height: 106px;
        }
      }
    }
  }
}
</style>
